/* ============================================
   ALnoor Theme — Media Gallery JavaScript
   Thumbnail navigation, image zoom on hover,
   touch swipe support on mobile.
   ============================================ */

(function () {
  'use strict';

  class MediaGallery {
    constructor(container) {
      this.container = container;
      this.currentIndex = 0;
      this.images = [];
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.swipeThreshold = 50;

      this.init();
    }

    init() {
      this.cacheDOM();
      if (this.thumbnails.length === 0) return;
      this.bindEvents();
    }

    cacheDOM() {
      this.mainImageWrap = this.container.querySelector(
        '[data-main-image-wrap]'
      );
      this.zoomContainer = this.container.querySelector('[data-image-zoom]');
      this.mainImage = this.zoomContainer
        ? this.zoomContainer.querySelector('.product-page__main-image')
        : null;
      this.thumbnails = Array.from(
        this.container.querySelectorAll('[data-thumbnail]')
      );
      this.prevBtn = this.container.querySelector('[data-gallery-prev]');
      this.nextBtn = this.container.querySelector('[data-gallery-next]');
      this.currentIndexEl = this.container.querySelector(
        '[data-current-index]'
      );

      /* Collect image data from thumbnails */
      this.images = this.thumbnails.map((thumb) => ({
        src: thumb.getAttribute('data-image-src'),
        srcset: thumb.getAttribute('data-image-srcset'),
      }));
    }

    bindEvents() {
      /* Thumbnail clicks */
      this.thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          this.goToImage(index);
        });

        thumb.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.goToImage(index);
          }
        });
      });

      /* Navigation arrows */
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevImage());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextImage());
      }

      /* Image zoom on hover (desktop only) */
      if (this.zoomContainer && this.mainImage) {
        this.zoomContainer.addEventListener(
          'mousemove',
          this.onZoomMouseMove.bind(this)
        );
        this.zoomContainer.addEventListener(
          'mouseleave',
          this.onZoomMouseLeave.bind(this)
        );
      }

      /* Touch swipe (mobile) */
      if (this.mainImageWrap) {
        this.mainImageWrap.addEventListener(
          'touchstart',
          this.onTouchStart.bind(this),
          { passive: true }
        );
        this.mainImageWrap.addEventListener(
          'touchmove',
          this.onTouchMove.bind(this),
          { passive: true }
        );
        this.mainImageWrap.addEventListener(
          'touchend',
          this.onTouchEnd.bind(this),
          { passive: true }
        );
      }

      /* Keyboard navigation when gallery is focused */
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevImage();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextImage();
        }
      });
    }

    /* --- Image Navigation --- */
    goToImage(index) {
      if (index < 0 || index >= this.images.length) return;
      this.currentIndex = index;

      /* Update main image */
      if (this.mainImage && this.images[index]) {
        this.mainImage.src = this.images[index].src;
        if (this.images[index].srcset) {
          this.mainImage.srcset = this.images[index].srcset;
        }
      }

      /* Update active thumbnail */
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle(
          'product-page__thumbnail--active',
          i === index
        );
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      /* Scroll active thumbnail into view */
      if (this.thumbnails[index]) {
        this.thumbnails[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }

      /* Update counter */
      if (this.currentIndexEl) {
        this.currentIndexEl.textContent = index + 1;
      }
    }
    /* --- Change Gallery Image by Variant Image --- */
goToImageBySrc(imageSrc) {
  if (!imageSrc) return;

  const cleanSrc = imageSrc
    .split('?')[0]
    .replace(/^https?:/, '');

  const index = this.images.findIndex((image) => {
    if (!image.src) return false;

    const cleanImageSrc = image.src
      .split('?')[0]
      .replace(/^https?:/, '');

    return (
      cleanImageSrc.includes(cleanSrc) ||
      cleanSrc.includes(cleanImageSrc)
    );
  });

  if (index !== -1) {
    this.goToImage(index);
  }
}

    prevImage() {
      const newIndex =
        this.currentIndex > 0
          ? this.currentIndex - 1
          : this.images.length - 1;
      this.goToImage(newIndex);
    }

    nextImage() {
      const newIndex =
        this.currentIndex < this.images.length - 1
          ? this.currentIndex + 1
          : 0;
      this.goToImage(newIndex);
    }

    /* --- Image Zoom (Desktop) --- */
    onZoomMouseMove(e) {
      /* Skip on touch devices / small screens */
      if (window.innerWidth < 990) return;

      const rect = this.zoomContainer.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      this.mainImage.style.transformOrigin = `${x}% ${y}%`;
    }

    onZoomMouseLeave() {
      if (!this.mainImage) return;
      this.mainImage.style.transformOrigin = 'center center';
    }

    /* --- Touch Swipe (Mobile) --- */
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    }

    onTouchMove(e) {
      this.touchEndX = e.changedTouches[0].screenX;
    }

    onTouchEnd() {
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) < this.swipeThreshold) return;

      if (diff > 0) {
        /* Swipe left -> next image */
        this.nextImage();
      } else {
        /* Swipe right -> previous image */
        this.prevImage();
      }

      /* Reset */
      this.touchStartX = 0;
      this.touchEndX = 0;
    }
  }

  /* --- Initialize --- */
  function initGalleries() {
    const galleries = document.querySelectorAll('[data-media-gallery]');
    galleries.forEach((gallery) => {
      if (!gallery._mediaGallery) {
        gallery._mediaGallery = new MediaGallery(gallery);
      }
    });
  }

  /* Init on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  } else {
    initGalleries();
  }

  /* Re-init on Shopify section load (Theme Editor) */
  document.addEventListener('shopify:section:load', initGalleries);
})();
